export const permissions = {
    permissions: ['GEN_AI_LANDING_PAGES_VIEW'],
};

export const templateSelectionPermission = 'GEN_AI_LANDING_PAGES_TEMPLATE_SELECTION';
